import { useI18n } from '@i18n/I18nProvider'
import { useState } from 'react'
import { Photo } from './Photo'

// Fotos de un lugar: la elegida en grande y, si hay más de una, miniaturas para cambiarla
// (botones de 64 px, cada uno con "Foto n de total").
export const PhotoGallery = ({ photos, alt }: { photos: string[]; alt: string }) => {
	const { t } = useI18n()
	const [current, setCurrent] = useState(0)
	const shown = photos[current] ?? photos[0]
	if (!shown) return null
	return (
		<div className="mb-4">
			<Photo src={shown} alt={alt} className="aspect-[4/3] w-full rounded-3xl object-cover" />
			{photos.length > 1 && (
				<ul className="mt-2 flex gap-2 overflow-x-auto">
					{photos.map((photo, index) => (
						<li key={photo} className="shrink-0">
							<button
								type="button"
								aria-pressed={index === current}
								aria-label={t('places.photo', { n: index + 1, total: photos.length })}
								onClick={() => setCurrent(index)}
								className={`block overflow-hidden rounded-xl border-4 ${index === current ? 'border-forest-700' : 'border-transparent'}`}
							>
								<Photo src={photo} alt="" className="size-16 object-cover" />
							</button>
						</li>
					))}
				</ul>
			)}
		</div>
	)
}
